<div class="main-tab-title-box">
  <mat-card-title class="main-title">Lexis: Academic Word List</mat-card-title>
  <div>
    <analysis-options></analysis-options>
  </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysis will begin after you finish typing</div>
</div>
<div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>
<mat-card-content>
  <div *ngIf="short_words" class="message">
    <div class="line"></div>
    <p>Lexical scores are not accurate on short documents.</p>
  </div>
  <div id="button-switch-box">
    <div class="button-container left" [ngClass]="{'selected': isSelected('summary')}"
      (click)="selectMenuItem('summary')">
      <div style="margin-top: 9px;">
        <span class="main-box-title-14">Summary</span>
      </div>
    </div>
    <div class="separator"></div>
    <div class="button-container right" [ngClass]="{'selected': isSelected('charts')}"
      (click)="selectMenuItem('charts')">
      <div style="margin-top: 8px;">
        <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;"
          src="./assets/images/extra_tab_icons/charts-icon.svg">
        <span class="main-box-title-14" style="padding-top: 2px;">Charts</span>
      </div>
    </div>
  </div>
  <span class="main-box-title-16">Word List</span>
  <span class="main-box-title-14"><br>This tool analyses your text according to the Academic Word List or AWL
    (Coxhead, 2000).
    Click <a href="https://textinspector.com/help/academic-word-list-and-phrases/" class="hiperlinks" target="_blank" rel="noopener noreferrer">HERE</a> for an
    explanation. It also analyses your text in terms of key Phrases identified by Martinez and
    Schmitt (Martinez and Schmitt, 2012), identified as K1, K2 and so on, as discussed <a
      href="https://textinspector.com/help/analysing-vocabulary-using-the-phrase-list/" class="hiperlinks" target="_blank" rel="noopener noreferrer">HERE</a>.
    If you want to correct any analysis, go to Input below, change the tag, then click Update.</span>


  <!--------------------------------------------->
  <!--------------------------------------------->
  <!-----------------WORD LIST------------------->
  <!--------------------------------------------->
  <!--------------------------------------------->

  <ng-container *ngIf="selectedMenuItem === 'summary'">

    <div id="buttons-box">
      <div style="width: 70px;">

      </div>
      <span style="padding-left: 15px;">
        <button [matMenuTriggerFor]="fileMenu" class="icon-button" (click)="toggleIcon()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">

          <span class="button-export">
            <div><img src="../assets/images/export-con.svg" class="export-con"></div><span>Lexis:
              AWL
              Export</span>
          </span>
          <mat-icon class="right-icon" [ngClass]="{'rotated-icon': isIconRotated, 'normal-icon': !isIconRotated}">expand_more</mat-icon>
        </button>
        <mat-menu #fileMenu="matMenu" (closed)="resetIcon()" xPosition="before">
          <button mat-menu-item (click)="export_detallado()">Export Statistics And Details</button>
          <button mat-menu-item (click)="export_tagger()">Export Tagged Data</button>
        </mat-menu>
      </span>

    </div>
    <div class="content-show-all">
      <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
        {{ showAll ? 'Expand all' : 'Contract all' }}
      </button>
    </div>

    <ng-container *ngIf="checked">

      <!--------------------------->
      <!--------------------------->
      <!------Advanced Mode-------->
      <!--------------------------->
      <!--------------------------->
      <div class="div_scroll_box">
        <div id="awl-box">
          <div style="width: 70px;">
            <button class="button-seeAll" *ngIf="!hideEyeIconsForSafari1561" (click)="toggleSeeAll()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
              <img class="see-all-icon eye-icon" style="padding-left: 10px;" [src]="seeAllIconSrc" >
              <span class="main-box-title-12">See All</span>
            </button>
          </div>
          <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 80px;">Word</div>
          <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 90px;">Types</div>
          <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 80px;">Tokens</div>
          <div style=" text-align: left; width: 65px; ">
            <div class="main-box-title-12">Cumul %</div>
            <div class="main-box-title-12">Types</div>
          </div>
          <div style=" text-align: left; width: 70px; ">
            <div class="main-box-title-12">Cumul %</div>
            <div class="main-box-title-12">Tokens</div>
          </div>
          <div style="width: 32px; height: 20px; "></div>
        </div>

        <ng-container *ngFor="let data of getObjectKeys(encabezados)">
          <div class="vertical-box">
            <div *ngIf="selectedWord[data]" id="div-category">
               <div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="display: flex;">
                <button class="reset-button" (click)="resetCategoryView(data)">
                  <img src="./assets/images/black_icons/back-Icon.svg">
                </button>
                <div class="main-box-title-16" style="padding-top: 1px;">Change Tag</div>
              </div>
              <button class="main-box-title-14 update-button" (click)="updateCategory(data)">Update</button>
            </div>
              <ng-container *ngFor="let index of [].constructor(encontrarCantidad(selectedWord[data],data.toUpperCase() )); let i = index">
                <div style="margin-bottom: 25px; margin-top: 10px;">
                  <div class="horizontal-box" style="border: none; margin-bottom: 0px;">
                    <div class="main-box-title-12"><img *ngIf="!hideEyeIconsForSafari1561" class="eye-icon"
                      [src]="palabraSeleccionada[data.toUpperCase() + '-' + selectedWord[data] + '-' + i] 
                            ? '../../assets/images/yellow_icons/eye-on-icon.svg' 
                            : '../../assets/images/eye-icon.svg'"
                      (click)="verPalabra(selectedWord[data], data, i,true)"><strong>Word:</strong> {{selectedWord[data]}}</div>
                    <div class="main-box-title-12"><strong>Part of speech:</strong> {{ data.toUpperCase() }}</div>
                    <!-- <div class="main-box-title-12"><strong>Encontradas:</strong> {{data_pof[data.toUpperCase()][selectedWord[data]]}}</div> -->
                  </div>

                  <div *ngIf="respuestaWords" class="main-box-title-12" style="display: grid;grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));gap: 10px; margin-left: 10px; margin-top: 10px;">
                    <div *ngFor="let item of respuestaWords" style="display: flex; align-items: flex-start;">
                        <input type="radio" 
                          name="palabra-{{i}}" 
                          [value]="item.value" 
                          [checked]="isWordSelected(item.value, data, item)"
                          (change)="onSelectionRadioChange(selectedWord[data], i, data, item.value, item.descripcion); verPalabra(selectedWord[data], data, i,false)" 
                          />
                          <!-- [checked]="isWordSelected(data, i, item)" -->
                        <td class="custom-cell description-cell" style="text-align: left;">{{ item.descripcion }}</td>
                    </div>
                </div>
              </div>
              </ng-container>
  
            </div>
            <div *ngIf="!selectedWord[data]">
            <div class="horizontal-box" style="border: none; margin-bottom: 0px; cursor: pointer;" (click)="data !== 'awlTotal' && toggleExpand(encabezados[data].Name)"
              [ngClass]="{'expanded': isExpanded[encabezados[data].Name]}" >
              <div id="div_eye_icon" [ngStyle]="data === 'awlTotal' ? {'visibility': 'hidden', 'display': 'inline-block'} : {}">
                <img *ngIf="!hideEyeIconsForSafari1561" class="eye-icon" [src]="isEyeOn[data.toUpperCase()] ? './assets/images/yellow_icons/eye-on-icon.svg' : './assets/images/eye-icon.svg'"
                  (click)="toggleEyeIcon(data); $event.stopPropagation()">
              </div>
              <div style="display: flex;" *ngIf="data == 'unlisted'">
                <span id="box-score" [ngStyle]="{'background-color': colores_dinamicos[data], 'color':'#2A3654'}">{{encabezados[data].Name}}  </span>
                <div class="tooltip-container" (click)="$event.stopPropagation()">
                  <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                  <span class="tooltip-text">Words in your text that are not found in the AWL word list.</span>
                </div>
              </div>
                <span id="box-score" *ngIf="data == 'awlTotal'"
                [ngStyle]="{'background-color': colores_dinamicos[data], 'color':'#2A3654'}">{{encabezados[data].Name}}</span>
              <span id="box-score" *ngIf="data != 'unlisted' && data != 'awlTotal'"
                [ngStyle]="{'background-color': colores_dinamicos[data]}">{{encabezados[data].Name}}</span>
              <div class="main-box-title-14" id="div__types">
                {{encabezados[data].unique_words ? encabezados[data].unique_words : "--"}} ({{encabezados[data].cumul_unique ? encabezados[data].cumul_unique : "--"}})
              </div>
              <div class="main-box-title-14" id="div_tokens">
                {{encabezados[data].words ? encabezados[data].words : "--"}} ({{encabezados[data].cumul_words ? encabezados[data].cumul_words : "--"}})
              </div>
              <div class="main-box-title-14" id="div_c_types">
                {{encabezados[data].suma_unique_words ? encabezados[data].suma_unique_words : "--"}}</div>
              <div class="main-box-title-14" id="div_c_tokens">
                {{encabezados[data].suma_cumul_words ? encabezados[data].suma_cumul_words : "--"}}</div>
              <mat-icon class="expand-icon" 
                [ngStyle]="data == 'awlTotal' ? {'visibility': 'hidden', 'display': 'inline-block'} : {}">expand_more</mat-icon>
            </div>
            <div class="words-content"
              *ngIf="isExpanded[encabezados[data].Name]">
              <ng-container *ngFor="let item of getObjectKeys(data_pof[data.toUpperCase()])">
                <div class="item-listado-errores">
                  <span (mouseenter)="ponerOjo($event, data, item)" (mouseleave)="quitarOjo($event, data, item)"
                    style="display:flex; padding: 4px;">
                    <ng-container *ngIf="isScreenLarge; else mobileLayout">
                      <img src="./assets/images/eye-icon.svg" *ngIf="!palabraresaltada[data.toUpperCase()]?.[item] && !hideEyeIconsForSafari1561"
                        (click)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 5px;">
                      <img src="./assets/images/yellow_icons/eye-on-icon.svg" *ngIf="palabraresaltada[data.toUpperCase()]?.[item] && !hideEyeIconsForSafari1561"
                        (click)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 5px;">
                      <img src="./assets/images/project-icon.svg" style="margin-right: 5px;" (click)="selectWord(data, item)" class="icon-project">
                      <div>
                        {{item}} / {{data_pof[data.toUpperCase()][item]}}
                      </div>
                    </ng-container>

                    <ng-template #mobileLayout>
                      <img src="./assets/images/eye-icon.svg" *ngIf="!palabraresaltada[data.toUpperCase()]?.[item] && !hideEyeIconsForSafari1561"
                        (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 6px;">
                      <img src="./assets/images/yellow_icons/eye-on-icon.svg" *ngIf="palabraresaltada[data.toUpperCase()]?.[item] && !hideEyeIconsForSafari1561"
                        (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 6px;">
                      <img src="./assets/images/project-icon.svg" style="margin-right: 5px;" (click)="selectWord(data, item)" class="icon-project">
                      <div>
                        {{item}} / {{data_pof[data.toUpperCase()][item]}}
                      </div>
                    </ng-template>
                  </span>
                </div>
              </ng-container>
            </div>
            </div>
          </div>
        </ng-container>

      </div>
    </ng-container>

    <!--------------------------->
    <!--------------------------->
    <!--------Simple Mode-------->
    <!--------------------------->
    <!--------------------------->

    <ng-container *ngIf="!checked">

      <div class="div_scroll_box">
            <div id="awl-box" >
                <div style=" margin-left: 10px; margin-right: 2%; " >
                  <button *ngIf="!hideEyeIconsForSafari1561" class="button-seeAll-Simple" (click)="toggleSeeAll()">
                    <img class="see-all-icon eye-icon" style="padding-left: 12px; margin-right: 4px;" [src]="seeAllIconSrc">
                    <span class="main-box-title-12">See All</span>
                  </button>
                </div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 70px;margin-left: 9%; ">Word</div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">Types</div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">Tokens</div>
                <div style="width: 25%; height: 10px; "></div>
            </div>
            <ng-container *ngFor="let data of getObjectKeys(encabezados)">
              <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                  [ngClass]="{'expanded': isExpanded[data]}" (click)="data !== 'awlTotal' && toggleExpand(encabezados[data].Name)">
                  <img class="eye-icon" *ngIf="!hideEyeIconsForSafari1561" (click)="toggleEyeIcon(data); $event.stopPropagation()"
                    [src]="imgSrc[data] || '../../assets/images/eye-icon.svg'"
                    [ngStyle]="data == 'awlTotal' ? {'visibility': 'hidden', 'display': 'inline-block'} : {}">
                  <div style="width: 12%; height: 20px;"></div>
                  <span id="box-score" *ngIf="data == 'unlisted' || data == 'awlTotal'"
                    [ngStyle]="{'background-color': colores_dinamicos[data], 'color':'#2A3654'}">{{encabezados[data].Name}}</span>
                  <span id="box-score" *ngIf="data != 'unlisted' && data != 'awlTotal'"
                    [ngStyle]="{'background-color': colores_dinamicos[data]}" style="margin-right: 6%;">{{encabezados[data].Name}}</span>
                  <div class="main-box-title-14" id="div__types">{{encabezados[data].unique_words ?
                    encabezados[data].unique_words : "--"}}</div>
                  <div class="main-box-title-14" id="div_tokens">{{encabezados[data].words ? encabezados[data].words :
                    "--"}}</div>
                  <div style="width: 12%; height: 20px;"></div>
                  <mat-icon class="expand-icon" 
                    [ngStyle]="data == 'awlTotal' ? {'visibility': 'hidden', 'display': 'inline-block'} : {}">expand_more</mat-icon>
                </div>
                <div
                class="words-content"
                  *ngIf="isExpanded[encabezados[data].Name]">
                  <ng-container *ngFor="let item of getObjectKeys(data_pof[data.toUpperCase()])">
                    <div class="item-listado-errores">
                      <span (mouseenter)="ponerOjo($event, data, item)" (mouseleave)="quitarOjo($event, data, item)"
                        style="display:flex; padding: 4px;">
                        <ng-container *ngIf="isScreenLarge; else mobileLayout">
                          <img src="./assets/images/eye-icon.svg" *ngIf="!palabraresaltada[data][item] && !hideEyeIconsForSafari1561"
                            (click)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 5px;">
                          <img src="./assets/images/yellow_icons/eye-on-icon.svg" *ngIf="palabraresaltada[data][item] && !hideEyeIconsForSafari1561"
                            (click)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 5px;">
                          <div>
                            {{item}} / {{data_pof[data.toUpperCase()][item]}}
                          </div>
                        </ng-container>
    
                        <ng-template #mobileLayout>
                          <img src="./assets/images/eye-icon.svg" *ngIf="!palabraresaltada[data][item] && !hideEyeIconsForSafari1561"
                            (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 6px;">
                          <img src="./assets/images/yellow_icons/eye-on-icon.svg" *ngIf="palabraresaltada[data][item] && !hideEyeIconsForSafari1561"
                            (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 6px;">
                          <div>
                            {{item}} / {{data_pof[data.toUpperCase()][item]}}
                          </div>
                        </ng-template>
                      </span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
<!--             
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['UNLISTED']}">
                <img class="eye-icon" (click)="toggleEyeIcon($event)" src="../../assets/images/eye-icon.svg">
                <div style="width: 0px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #F3F3F5; color: #2A3654;">Unlisted</span>
                  <div class="tooltip-container">
                    <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                    <span class="tooltip-text">Lorem ipsum dolor sit amet consetetur sad ipscing elitr sed diam nonumy eirmod temi por invidunt ut labore et dolore magna.</span>
                  </div>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_unlisted ? types_unlisted : "--"}} (92.34%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_unlisted ? words_unlisted : "--"}} (94.29%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" (click)="toggleExpand('UNLISTED')">expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['UNLISTED']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['UNLISTED']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>             -->

          </div>
    </ng-container>

  </ng-container>

  <!--------------------------------------------->
  <!--------------------------------------------->
  <!----------------WORD CHARTS------------------>
  <!--------------------------------------------->
  <!--------------------------------------------->

  <ng-container *ngIf="selectedMenuItem === 'charts'">
    <div class="chart-container">
      <div
        style="width: auto;align-items: center; text-align: center; font-size: 14px; font-weight: bold; font-family: 'Inter';color: #2A3654; margin-bottom: 20px;">
        Types %</div>
        <div class="scroll_chart">
          <div class="size_chart">
      <canvas style="width: 100%; height: 300px; margin-left: 1%;margin-right: 1%; padding-bottom: 10px;" baseChart
        [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
      </canvas>
    </div>
    </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!checked">
    <div class="text-box-bottom-simple-mode">
      <div class="line-box-bottom-simple-mode">
        <div class="bottom-text-line-simple-mode"></div>
      </div>
      <span class="main-box-title-14">To see full statistics, switch to “Advanced Mode”.</span>
    </div>
  </ng-container>

</mat-card-content>
